const generateLivestreamingStats = cards => {
  const c = cards || {};
  const rate = Number(c.removal_success_rate);
  const rateDisplay = Number.isFinite(rate) ? `${rate.toFixed(1)}%` : '0%';

  return [
    {
      title: 'Active campaigns',
      subtitle: 'Campaigns',
      total: c.active_targets ?? 0,
      chartData: [{ name: 'Trend', data: [12, 18, 14, 22, 16, 20, 19, 24, 21, 17, 23, 20] }],
      chartType: 'bar',
    },
    {
      title: 'Reported streams',
      subtitle: 'Streams',
      total: c.reported_streams ?? 0,
      chartData: [{ name: 'Trend', data: [45, 52, 38, 61, 55, 48, 59, 63, 57, 50, 54, 58] }],
      chartType: 'line',
    },
    {
      title: 'Removed streams',
      subtitle: 'Streams',
      total: c.removed_streams ?? 0,
      chartData: [{ name: 'Trend', data: [38, 44, 40, 50, 46, 42, 48, 52, 49, 45, 47, 51] }],
      chartType: 'line',
    },
    {
      title: 'Removal success rate',
      subtitle: 'Removed vs reported',
      total: rateDisplay,
      chartData: [72, 75, 70],
      chartType: 'pie',
    },
  ];
};

export default generateLivestreamingStats;
